var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276 -233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(-276 233)",
    fill: "#dae0e7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-260.953 261.677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-244.57,277.083a12.514,12.514,0,0,1-12.5-12.5h2a10.512,10.512,0,0,0,10.5,10.5,10.512,10.512,0,0,0,10.5-10.5h2A12.515,12.515,0,0,1-244.57,277.083Z",
    transform: "translate(257.07 -264.583)",
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-256.973 277.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.497 272.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5.527,
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-242.746 243.253)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-247.937 247.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-237.82,264.333a6.759,6.759,0,0,1-6.75,6.75,6.758,6.758,0,0,1-6.75-6.75v-10.5a6.758,6.758,0,0,1,6.75-6.75,6.7,6.7,0,0,1,3.564,1.028h1.183v-1.618a8.686,8.686,0,0,0-4.747-1.41,8.759,8.759,0,0,0-8.75,8.75v10.5a8.76,8.76,0,0,0,8.75,8.75,8.76,8.76,0,0,0,8.75-8.75v-5.211h-2Z",
    transform: "translate(-3.902 -2.685)",
    fill: "#0d1b4b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.2b4e942de2baf57a0b91e183cb2a278e.svg";
export { ForwardRef as ReactComponent };